
// import '@/plugin/element.js'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/config/axios.js'

// 引入 Element UI 并注册
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css' // 引入样式

// 关闭生产提示
Vue.config.productionTip = false

// 注册 Element UI
Vue.use(ElementUI)

// 创建全局事件总线（可选）
Vue.prototype.$bus = new Vue()

// 创建 Vue 实例并挂载
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
